// extracted by mini-css-extract-plugin
export default {"meinian-waterfall-card-item":"index_meinian-waterfall-card-item__Ep429"};